var _title, _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconSelectItems = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 49 35",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Select Values icon")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Query-Filtering",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Notes",
  transform: "translate(-254.000000, -451.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Select-Items-default",
  transform: "translate(233.000000, 451.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Select-Values-icon",
  transform: "translate(21.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m2.284 3.634.719.723L6.384.782a1.047 1.047 0 0 1 1.502-.02A1.1 1.1 0 0 1 7.902 2.3L4.028 6.344a1.44 1.44 0 0 1-2.058.021L.76 5.155A1.08 1.08 0 0 1 .762 3.63a1.075 1.075 0 0 1 1.522.003",
  id: "Imported-Layers",
  fill: "#81848F"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#81848F",
  x: 10.8088235,
  y: 0.72,
  width: 38.1911765,
  height: 5.76,
  rx: 2.88
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#D1D3D4",
  x: 10.8088235,
  y: 10.08,
  width: 38.1911765,
  height: 5.76,
  rx: 2.88
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#81848F",
  x: 10.8088235,
  y: 19.44,
  width: 38.1911765,
  height: 5.76,
  rx: 2.88
}), /*#__PURE__*/React.createElement("path", {
  d: "m2.284 22.354.719.723 3.381-3.575a1.047 1.047 0 0 1 1.502-.02 1.1 1.1 0 0 1 .016 1.538l-3.874 4.044a1.44 1.44 0 0 1-2.058.021L.76 23.875a1.08 1.08 0 0 1 .001-1.524 1.075 1.075 0 0 1 1.522.003",
  id: "Imported-Layers",
  fill: "#81848F"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#81848F",
  x: 10.8088235,
  y: 28.8,
  width: 38.1911765,
  height: 5.76,
  rx: 2.88
}), /*#__PURE__*/React.createElement("path", {
  d: "m2.284 31.714.719.723 3.381-3.575a1.047 1.047 0 0 1 1.502-.02 1.1 1.1 0 0 1 .016 1.538l-3.874 4.044a1.44 1.44 0 0 1-2.058.021L.76 33.235a1.08 1.08 0 0 1 .001-1.524 1.075 1.075 0 0 1 1.522.003",
  id: "Imported-Layers",
  fill: "#81848F"
}))))))));
export default SvgIconSelectItems;